<template>
  <v-layout row>
    <v-flex xs12>
    <v-toolbar app>
    <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
    <v-toolbar-title>Delivery</v-toolbar-title>
    <v-spacer></v-spacer>
     <v-btn icon to="/delivery-form" >
              <v-icon>add</v-icon>
            </v-btn>
  </v-toolbar>
        <v-list two-line class="list-view" v-if="items.length > 0">
          <template v-for="(item) in items" >
            <v-list-tile class="list-view-item"
              :key="item.title"
              avatar
              ripple
              
            >
              <v-list-tile-content>
                <v-list-tile-title :class="'bg-' + item.colorestatus + ' pack-title'">{{ item.desc_estatus_proceso }}</v-list-tile-title> 
                <!-- <v-list-tile-sub-title class="text--primary">{{ item.headline }}</v-list-tile-sub-title>
                <v-list-tile-sub-title class="mb5">{{ item.subtitle }}</v-list-tile-sub-title> -->
                <span class="list-view-item-date">{{item.fec_creacion}}</span>
                <table class="pack-list-table">
                  <tr>
                    <th>Dirección</th>
                    <td>{{item.direccion_entrega}}</td>
                  </tr>
                  <tr>
                    <th>Codigo de Solicitud</th>
                    <td>{{item.codigo}}</td>
                  </tr>
                  <tr>
                    <th>Telefono</th>
                    <td>{{item.telefono1}}</td>
                  </tr>                  
                  
                </table>
                
              </v-list-tile-content>
              
            </v-list-tile>

          </template>
        </v-list>
        <div v-else>
          <img src="../assets/nodatos.jpg" class="noData" alt="" v-if="noData">
          <v-progress-circular
            :size="90"
            color="blue"
            indeterminate
            class="loading-center"
            v-else
          ></v-progress-circular>
        </div>
        </v-flex>
  </v-layout>
</template>

<script>
import Helpers from '../utils/helpers'
import Server from '../utils/server'
export default {
    created() {
    this.$store.watch(
      (state, getters) => getters.user, 
      (newValue, oldValue) => {
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if(this.currentUser != undefined){
            console.log(this.currentUser);
            this.getPacks();  
          }
          
        }
      },
    );
  },
  mounted () {
    if(this.currentUser != undefined){
      this.getPacks();  
    }else if(this.user.userName != null ){
      this.currentUser = this.user;
      this.getPacks(); 
    }
  },
  data () {
    return {
      clipped: false,
      items: [],
      currentUser: undefined,
      noData:false,
      loading: false,
      guia:null,
      idpack:null
    }
  },
  computed: {
    user(){
      return this.$store.getters.user;
    },
    login(){
      return this.$store.getters.login;
    }
  },
  methods: {
    getPacks(){
      var formData = new FormData()
        formData.append('text1', this.currentUser.userName) 
        formData.append('text3', this.currentUser.pushId)
        formData.append('device', window.MobileApi.device)
        console.log(this.currentUser); 
      this.$http.post(Server.DeliveryRequest, formData)  
          .then( 
            response => {
              console.log(response.body);
              if(response.body.resultado !=="NO"){
                this.items = response.body
              }else{
                this.noData = true;
              }
              
            },
            () => {
              this.error = true;
              this.msj = "Try again later";
            }
          );
    },
    pickFile (guia,idpack) {
       window.MobileApi.uploadInvoice(Server.uploadInvoicePrealerta, guia, idpack, this.currentUser.userName,this.getPacks);
    },
    onFilePicked(){
      this.loading = true;
      if(files[0] !== undefined) {
          this.imageName = files[0].name
          if(this.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader ()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.imageFile = files[0] // this is an image file that can be sent to server...
            var formData = new FormData()
            formData.append('text1', this.currentUser.userName) 
            formData.append('text3', this.currentUser.pushId)
            formData.append('device', window.MobileApi.device)
            formData.append('PARAMETRO2', this.guia)
            formData.append('PARAMETRO1', this.idpack)
            formData.append('photo', this.imageFile)
            this.$http.post(Server.uploadInvoice, formData)  
                .then( 
                  response => {
                    this.loading = false;
                    
                  },
                  () => {
                    this.loading = false;
                  }
                );
          })
        } 
      
    }
  },
  name: 'App'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
